const PINCODE_STORAGE_KEY = "saved_delivery_pincode";


// Add 1 day to the delivery date
function addOneDayToEDD(etd) {
  if (!etd) return etd;

  // Format: YYYY-MM-DD
  if (/^\d{4}-\d{2}-\d{2}$/.test(etd)) {
    const [year, month, day] = etd.split("-").map(Number);

    const date = new Date(year, month - 1, day);
    date.setDate(date.getDate() + 1);

    return [
      date.getFullYear(),
      String(date.getMonth() + 1).padStart(2, "0"),
      String(date.getDate()).padStart(2, "0"),
    ].join("-");
  }

  // Format: DD-MM-YYYY or DD/MM/YYYY
  if (/^\d{2}[-/]\d{2}[-/]\d{4}$/.test(etd)) {
    const separator = etd.includes("/") ? "/" : "-";

    const [day, month, year] = etd
      .split(separator)
      .map(Number);

    const date = new Date(year, month - 1, day);

    date.setDate(date.getDate() + 1);

    return [
      String(date.getDate()).padStart(2, "0"),
      String(date.getMonth() + 1).padStart(2, "0"),
      date.getFullYear(),
    ].join(separator);
  }

  // Fallback for formats like:
  // "23 Aug 2026"
  // "August 23, 2026"
  const parsedDate = new Date(etd);

  if (!isNaN(parsedDate.getTime())) {
    parsedDate.setDate(parsedDate.getDate() + 1);

    return parsedDate.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  }

  // If date format cannot be detected,
  // return original API value
  return etd;
}


async function checkPincode() {
  const pincodeInput = document.getElementById("pincode");
  const resultDiv = document.getElementById("result");

  if (!pincodeInput || !resultDiv) return;

  const pincode = pincodeInput.value.trim();

  // Validate Indian 6-digit pincode
  if (!pincode || !/^\d{6}$/.test(pincode)) {
    resultDiv.innerHTML =
      "Please enter a valid 6-digit pincode.";

    return;
  }

  resultDiv.innerHTML = "Checking...";

  try {
    const response = await fetch(
      "https://main.d317fv511yfxyh.amplifyapp.com/api/check-pin",
      {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          pincode: pincode,
        }),
      }
    );

    const data = await response.json();

    console.log("API Response:", data);

    if (
      response.status === 200 &&
      data.data?.available_courier_companies?.length
    ) {
      // Original EDD from API
      const originalEtd =
        data.data.available_courier_companies[0].etd;

      console.log("Original EDD:", originalEtd);

      // Add one extra day
      const etd = addOneDayToEDD(originalEtd);

      console.log("Modified EDD:", etd);

      const resultHTML = `
        <p>
          <b>Expected Delivery:</b><span>${etd}</span>
        </p>
      `;

      resultDiv.innerHTML = resultHTML;

      // Save pincode + modified EDD
      localStorage.setItem(
        PINCODE_STORAGE_KEY,
        JSON.stringify({
          pincode: pincode,
          etd: etd,
          checkedAt: Date.now(),
        })
      );
    } else {
      resultDiv.innerHTML =
        "No available courier services for this pincode.";

      // Save pincode even if delivery isn't available
      localStorage.setItem(
        PINCODE_STORAGE_KEY,
        JSON.stringify({
          pincode: pincode,
          etd: null,
          checkedAt: Date.now(),
        })
      );
    }
  } catch (error) {
    console.error("Error:", error);

    resultDiv.innerHTML =
      "Error fetching data. Please try again.";
  }
}


// Restore previously checked pincode
function restorePincode() {
  const pincodeInput = document.getElementById("pincode");
  const resultDiv = document.getElementById("result");

  if (!pincodeInput || !resultDiv) return;

  try {
    const savedData =
      localStorage.getItem(PINCODE_STORAGE_KEY);

    if (!savedData) return;

    const data = JSON.parse(savedData);

    if (!data?.pincode) return;

    // Restore pincode
    pincodeInput.value = data.pincode;

    // Restore previously modified EDD
    if (data.etd) {
      resultDiv.innerHTML = `
        <p>
          <b>Expected Delivery:</b><span>${data.etd}</span>
        </p>
      `;
    } else {
      resultDiv.innerHTML =
        "No available courier services for this pincode.";
    }
  } catch (error) {
    console.error(
      "Error restoring pincode:",
      error
    );
  }
}


// Restore saved pincode after page loads
if (document.readyState === "loading") {
  document.addEventListener(
    "DOMContentLoaded",
    restorePincode
  );
} else {
  restorePincode();
}